import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../utils/analytics';
export function usePageTracking(): void {
  const location = useLocation();
  useEffect(() => {
    analytics.page();
  }, [location.pathname, location.search]);
}
